import { AutogenLayoutBillingCommentsQuickInfo } from "./autogen/AutogenLayoutBillingCommentsQuickInfo";


export class BillingCommentsQuickInfo extends AutogenLayoutBillingCommentsQuickInfo {

}
